import { isOneOf } from './isOneOf';

const ThrottlingErrors: string[] = [
    'OverBudget',
    'TooManyObjectsOpened',
    'ErrorServerBusy',
    'MailboxStoreUnavailable',
];

export function isThrottlingError(message: string | undefined): boolean {
    return isOneOf(ThrottlingErrors, message);
}
